import React from 'react'
import UserNav from '../UserComponents/UserNav'
import UserSidebar from '../UserComponents/UserSidebar'
import WorkloadView from '../UserComponents/WorkloadView'
import WorkHeatmap from '../UserComponents/WorkHeatmap'
import { useWorkData } from "../UserComponents//useWorkData";
import DashboardTable from '../UserComponents/DashboardTable'

const DashBoard = () => {
  const workData = useWorkData();

  return (
    <div style={{ background: 'rgb(255, 255, 255)', height: '100vh' }}>
      <div className='flex'>
        <div>
          <UserSidebar />
        </div>
          <div className='w-full'>
          <UserNav />
          <DashboardTable />
          <WorkloadView />
          <WorkHeatmap workData={workData} />


          </div>
      </div>
    </div>
    
  )
}

export default DashBoard